const FALLBACK =
  "The campaign couldn't be saved. Everything you set up is still here. Try again.";

type ProblemDetails = {
  errors?: Record<string, unknown> | unknown[];
  devMessage?: string;
  detail?: string;
  title?: string;
};

function lineOf(value: unknown): string {
  if (typeof value === "string") return value.trim();
  const message = (value as { message?: unknown })?.message;
  return typeof message === "string" ? message.trim() : "";
}

function errorLines(errors: Record<string, unknown> | unknown[]): string[] {
  const flat = (Array.isArray(errors) ? errors : Object.values(errors)).flatMap(
    (value) => (Array.isArray(value) ? (value as unknown[]) : [value]),
  );
  return flat.map(lineOf).filter(Boolean);
}

/**
 * Why a create failed, shown above the Save draft / Go live buttons. Covers
 * both API errors (field errors, or the {message} list adkit envelopes use)
 * and a zod throw before the request left the browser, which has no `data`.
 */
export function createCampaignErrorMessage(err: unknown): string {
  const data = (err as { data?: ProblemDetails })?.data;

  if (data?.errors) {
    const lines = errorLines(data.errors);
    if (lines.length > 0) return lines.join(" ");
  }

  const banner = data?.devMessage ?? data?.detail ?? data?.title;
  if (typeof banner === "string" && banner.trim()) return banner.trim();

  const message = (err as { message?: unknown })?.message;
  if (typeof message === "string" && message.trim()) {
    return `${FALLBACK} (${message.trim()})`;
  }

  return FALLBACK;
}
